export function omitNilProperties(data: Record<string, any>) {
  const filteredData = Object.entries(data).filter(([_, val]) => val);

  return Object.fromEntries(filteredData);
}
